import React from "react";

const TableLayout = ({ children }) => {
  return <div className="card-section">{children}</div>;
};

export default TableLayout;
